import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Table,
  Button,
  FormGroup,Label,
} from 'reactstrap';
import $ from 'jquery';
import Loader from '../Loader/Loader';
import Sanitize from '../Sanitize';
import CKEditor from 'ckeditor4-react';
const GLOBAL = require('../Globals');

const red = {border : '0px',paddingBottom : '10px',color : 'red',fontWeight : 'bold'};
const green = {border : '0px',paddingBottom : '10px',color : 'green',fontWeight : 'bold'};
const black = {border : '0px',paddingBottom : '10px'};

class ViewStudentResult extends Component {
	
	constructor(props){
        MathJax.Hub.Config({
            tex2jax: {
                inlineMath: [['$', '$'], ['\\(', '\\)']],
                displayMath: [['$$', '$$'], ['\\[', '\\]']],
                jax: ["input/TeX", "input/MathML", "input/AsciiMath", "output/HTML-CSS", "output/NativeMML", "output/PreviewHTML"],
            },
            "HTML-CSS": {
                webFont: "TeX",
                automatic: false,
                matchFontHeight: true,
            },
            showMathMenu: false,
        });
        super(props);
		this.state = {
            data : [],
            result : [],
            imgdata : [],
            exam : this.props.exam,
            acyear : this.props.acyear,
            regno : this.props.regno,
            loading : false,
            modal : false,
        }
        this.printDocument = this.printDocument.bind(this);
    }

    printDocument() {
		
		var content = document.getElementById("studreport");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

    componentDidMount(){
        this.getdata();
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }

    componentDidUpdate() {
        $("span.math-tex").closest("p").css("display", "inline");
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
	}
    
    getdata(regno){
        this.setState({loading : true});
		GetData('question/getresultbystudent/'+this.state.acyear+'/'+this.state.exam+'/'+this.state.regno).then((result) => {
			let responseJson = result;
			if(responseJson.status==1){
                var mark = 0;
				this.setState({
                    result : responseJson.data,
                    examname : responseJson.data[0].examname,
                    examdate : responseJson.data[0].examdate,
                    fromtime : responseJson.data[0].fromtime,
                    totime : responseJson.data[0].totime,
                    sec : responseJson.data[0].sec,
                    noofmarks : responseJson.data[0].noofmarks,
                    totalmarks : responseJson.data[0].totalmarks,
                    subname : responseJson.data[0].subname,
                    clsname : responseJson.data[0].cls,
                    imgdata : responseJson.imgdata,
                    loading : false
                });
                responseJson.data.filter(function(obj){
                    mark+=parseInt(obj.mark);
                });
                this.setState({mark : mark});
			}
		});
    }

    getImageQuestion(id){
		var d = this.state.imgdata;
		var image = [];
		for(var i=0;i<d.length;i++){
			if(d[i].question == id){
				image.push(<img src={GLOBAL.BASE_URL+d[i].image} />);
			}
		}
		return image;
    }
    
    checkanswer(options,qid){
        var d = this.state.result;
        var result = black;
        var index = d.findIndex(function(obj){
            return(obj.question == qid);
        });
        if(index > -1){
            
            if(d[index].canswer == d[index].answer){
                if(options == d[index].canswer){
                    result = green;
                }
            }
            if(d[index].canswer != d[index].answer){
                if(options == d[index].canswer){
                    result = green;
                }
                else if(options == d[index].answer){
                    result = red;
                }
            }
            
        }
        return result;
    }
    
    render() {
    
        if (this.state.loading) {
			return (
				<Loader />
			)
		} else {
        return (<div>
            <Row id="studreport">
                <div style={{position: 'absolute',top: '-46px',right: '50px'}}>
                    <Button size="xs" color="warning" onClick={this.printDocument}><i className="fa fa-print"></i> Print</Button>
                </div>
                <Col md={12}>
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td align="center" colSpan="3" style={{fontSize : '18px',fontWeight : 'bold'}}>{GLOBAL.Scl_NAME}</td>
                            </tr>
                            <tr>
                                <td align="left">Name : <b>{this.props.stdname}</b></td>
                                <td align="center">Exam Name : <b>{this.state.examname}</b></td>
                                <td align="right">Subject : <b>{this.state.subname}</b></td>
                            </tr>
                            <tr>
                                <td align="left">Class : <b>{this.state.clsname} - {this.state.sec}</b></td>
                                <td align="center">Date : <b>{Sanitize.dmyDash(this.state.examdate)}</b></td>
                                <td align="right">No.of Questions : <b>{this.state.totalmarks/this.state.noofmarks}</b></td>
                            </tr>
                            <tr>
                                <td align="left">Regno : <b>{this.state.regno}</b></td>
                                <td align="center">Time : <b>{this.state.fromtime} to {this.state.totime}</b></td>
                                <td align="right">Total Marks : <b>{parseFloat(this.state.totalmarks)}</b></td>
                            </tr>
                        </tbody>
                    </table><br />
                    <Table responsive>
                        <tbody>
                            {this.state.result.map((item,i)=>
                                <React.Fragment>
                                    <tr>
                                        <td colSpan="4" style={{border : '0px',color : item.answer == 0 ? 'blue' : 'black'}} align="left">
                                            <FormGroup check inline>
                                                {i+1}.&emsp;<div dangerouslySetInnerHTML={{ __html: item.qusname }}></div>
                                                {this.getImageQuestion(item.questionid)}
                                            </FormGroup>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={this.checkanswer('option1',item.question)}>
                                            &emsp;&emsp;<FormGroup check inline>
                                                a)&nbsp;<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option1 }}></div>
                                                {item.optimage1!='' && item.optimage1!=null ? <img src={GLOBAL.BASE_URL+item.optimage1} /> : ''}
                                                </Label>
                                            </FormGroup>
                                        </td>
                                        <td style={this.checkanswer('option2',item.question)}>
                                            &emsp;&emsp;<FormGroup check inline>
                                                b)&nbsp;<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option2 }}></div>
                                                {item.optimage2!='' && item.optimage2!=null ? <img src={GLOBAL.BASE_URL+item.optimage2} /> : ''}
                                                </Label>
                                            </FormGroup>
                                        </td>
                                        <td style={this.checkanswer('option3',item.question)}>
                                            &emsp;&emsp;<FormGroup check inline>
                                                c)&nbsp;<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option3 }}></div>
                                                {item.optimage3!='' && item.optimage3!=null ? <img src={GLOBAL.BASE_URL+item.optimage3} /> : ''}
                                                </Label>
                                            </FormGroup>
                                        </td>
                                        <td style={this.checkanswer('option4',item.question)}>
                                            &emsp;&emsp;<FormGroup check inline>
                                                d)&nbsp;<Label className="form-check-label" check htmlFor="inline-radio"><div dangerouslySetInnerHTML={{ __html: item.option4 }}></div>
                                                {item.optimage4!='' && item.optimage4!=null ? <img src={GLOBAL.BASE_URL+item.optimage4} /> : ''}
                                                </Label>
                                            </FormGroup>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
        </div>)
        }
    }
}

export default ViewStudentResult;



// WEBPACK FOOTER //
// ./src/Questions/ViewStudentResult.js